'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styleTypes = require('./styleTypes');

exports.default = {
  fontFaces: _styleTypes.FONT_TYPE,
  statics: _styleTypes.STATIC_TYPE,
  keyframes: _styleTypes.KEYFRAME_TYPE,
  rules: _styleTypes.RULE_TYPE
};